import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/reevesdotnl/reevesdotnl/src/templates/pdf-view.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><img parentName="p" {...{
        "src": "/reevesdotnl/4eb152062271658f63d1c20ab15d779b/LIPs-2-2025-aug-27.gif",
        "alt": "LIPs related to plume heads - animation may take a few second to load"
      }}></img></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../animations"
        }}>{`Select another animation`}</a></li>
    </ul>
    <p>{`The main manifestations of plume heads on the earth's surface are a number of so-called `}<strong parentName="p">{`Large Igneous Provinces`}</strong>{` or LIPs.  These consist of very large areas of basalt, either as plateau basults on land
(e.g. the Deccan Traps of India) or large submarine plateaus (e.g. Kerguelen Plateau) or smaller submarine edifices entirely below the present surface of the oceans.  Often these features are accompanied
by dyke swarms and/or igneous intrusions.  When dated, the main features usually cluster around a rather short time interval, indicating a brief but intense period of magmatic activity
at the time the plume head first 'struck'.  Later plume activity is often less intense but, nevertheless, long-lived.  `}<strong parentName="p">{`Trails`}</strong>{` of plume activity, often with some
periods of rejuvenation, are found across the ocean floors (e.g. the Walvis Ridge off southwest Africa). Minor oceanic islands, still with occasional volcanic
activity, can be found (e.g. Bouvet island) associated with mantle plumes that broke out more than 180 million years ago. A number of `}<strong parentName="p">{`hotspots`}</strong>{` show similar trails
(e.g. Cameroon volcanic line) but lack the large areas of initial extrusion.`}</p>
    <p>{` The animation shows the development of the LIP record over time, 200 to 0 Ma, based on our latest Mantle Plume Reference Frame model that places the Bouvet ('Karoo')
plume central in Gondwana disruption.  A fuller explanation is given in Research Update No.21 (presently under revision). Areas of basalt are shown in red-brown, appearing at a time that reflects
the age-dates published, where available. Some of the known dyke swarms are shown as purple lines (e.g. the Okavango dyke swarm in southern Africa) and a few large
intrusions are purple with a red outline (e.g. Dufek in Antarctica). Many islands and submarine features are too small to show at this scale. It should be remembered that erosion has probably removed much of the volcanic sequences on land and it is only the present-day outlines of plateaus that are shown.`}</p>
    <p>{`Note the way in which crustal fragments, large and small (marked by red crosses), initially in the vicinity of the Bouvet plume early in the Jurassic (180 Ma) all find ways of moving away from it over time.  Their positions at intervals of 5 My are shown by small circles coloured pale blue. They are presumably carried on the mantle and reflect its convection. The animation also shows the travels of the three major continental fragments around the CAMP and Kerguelen plumes (blue-filled triangles) respectively.`}</p>
    <p>{` `}<em parentName="p">{`Last update: 2025 August 27`}</em></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../animations"
        }}>{`Select another animation`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../gondwana"
        }}>{`Return to Gondwana main page`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      